import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'doc-form-select',
    templateUrl: 'select.component.html',
    styleUrls: ['select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DocSelectComponent),
            multi: true
        }
    ]
})

export class DocSelectComponent implements ControlValueAccessor {
    
    @Input('parentForm') parentForm: UntypedFormGroup;
    @Input('controlName') controlName: string;
    
    @Input('label') label;
    @Input('width') width;
    @Input('default') default;
    @Input('options') options: {
        key: string,
        value: string
    }[];

    value: string = '';
    changed = (value: any) => { };
    touched = () => { };
    disabled: boolean;

    constructor() { }

    writeValue(value: any): void {
        this.value = value ? value : '';
    }
    registerOnChange(fn: any): void {
        this.changed = fn;
    }
    registerOnTouched(fn: any): void {
        this.touched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    selectionChanged(e) {
        this.changed(e.value);
        this.touched();
    }
}